define('OutSystems/ReactWidgets/ButtonGroup',["require", "exports", "tslib", "OutSystems/ReactView/Widget", "./AbstractButtonGroup"], function (require, exports, tslib_1, Widget_1, AbstractButtonGroup_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ButtonGroup = void 0;
    var ButtonGroup = (function (_super) {
        tslib_1.__extends(ButtonGroup, _super);
        function ButtonGroup() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ButtonGroup.prototype.getAdditionalPropsToChild = function () {
            return {};
        };
        ButtonGroup.prototype.getDataAttribute = function () {
            return "data-button-group";
        };
        ButtonGroup = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], ButtonGroup);
        return ButtonGroup;
    }(AbstractButtonGroup_1.AbstractButtonGroup));
    exports.ButtonGroup = ButtonGroup;
});
//# sourceMappingURL=ButtonGroup.js.map;
